import script from "./Iconic.vue?vue&type=script&setup=true&lang=js"
export * from "./Iconic.vue?vue&type=script&setup=true&lang=js"

import "./Iconic.vue?vue&type=style&index=0&id=18b744bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18b744bb"]])

export default __exports__